<template>
  <div class="row mt-0">

    <div class="col-md-12">
      <h4 class="title">{{ $t('form_answer') }}</h4>
    </div>

    <div class="col-md-12 card">
      <div class="card-header">
        <p-button class="btn btn-danger small" @click="createFormBuilder">
          <i class="fa fa-arrow-left"></i> {{ $t('back') }}
        </p-button>
      </div>
      <div class="card-body row">
        <div class="col-sm-6">
          <el-select v-model="pagination.perPage" :placeholder="$t('per_page')">
            <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
            >
            </el-option>
          </el-select>
        </div>
        <div class="col-sm-6">
          <div class="pull-right">
            <fg-input
              class="input-sm"
              placeholder="Search"
              v-model="searchQuery"
              addon-right-icon="nc-icon nc-zoom-split">
            </fg-input>
          </div>
        </div>
        <div class="col-sm-12 mt-2">
          <el-table
            v-loading="loading"
            :element-loading-text="$t('loading_data')+'...'"
            class="table-bordered"
            :data="queriedData"
            style="width: 100%"
          >
            <el-table-column
              v-for="column in tableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
            >
            </el-table-column>
            <el-table-column
              :min-width="50"
              class-name="td-actions text-center"
              :label="$t('actions')"
            >
              <template slot-scope="props">
                <p-button
                  type="primary"
                  size="sm"
                  title="Click to view responses"
                  icon
                  @click="viewAnswers(props.$index, props.row)"
                >
                  <i class="fa fa-eye"></i>
                </p-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-6 pagination-primary mt-3">
          <p class="category">
            {{ $t('showing') }} {{ from + 1 }} {{ $t('to') }} {{ to }} {{ $t('of') }} {{ total }} {{ $t('entries') }}
          </p>
        </div>
        <div class="col-sm-6 mt-3">
          <p-pagination
            class="pull-right"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total">
          </p-pagination>
        </div>
      </div>
    </div>

    <modal :show.sync="modals.classic" headerClasses="justify-content-center" :bodyClasses="'p-3'">
      <h4 slot="header" class="title title-up">{{ $t('form_responses') }}</h4>
      <template>
        <div v-for="(data, index) in formAnswers" :key="index">
          <p>
            <strong>{{ $t('question') }}: </strong>  {{ data.question }} <br>
            <strong>{{ $t('answer') }}: </strong> 
            <span v-if="data.status">
               <span v-for="(item, index) in data.answer" :key="index++">
                 {{ item }} <span v-if="index !== data.answer.length"> | </span>
               </span>
            </span> 
            <span v-else>{{ data.answer }}</span>
          </p>
        </div>
      </template>
      <template slot="footer">
        <div class="left-side">
          <p-button type="danger" link @click="handleCloseModal">{{ $t('cancel') }}</p-button>
        </div>
      </template>
    </modal>



  </div>
</template>
<script>
import PPagination from "src/components/UIComponents/Pagination.vue";

import Resource from "@/util/Api/resource.js";
import Modal from "src/components/UIComponents/Modal.vue";
const SurveyAnswerResource = new Resource("survey/answers");

export default {
  components: {
     PPagination,
     Modal
  },
  computed: {
    pagedData() {
        return this.tableData.slice(this.from, this.to);
    },
    queriedData() {
      if (!this.searchQuery) {
        this.pagination.total = this.tableData.length;
        return this.pagedData;
      }
      let result = this.tableData.filter(row => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          let rowValue = row[key].toString();
          rowValue = rowValue.toLowerCase();
          this.searchQuery = this.searchQuery.toLowerCase();
          if (rowValue.includes && rowValue.includes(this.searchQuery)) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
         highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      this.pagination.total = this.tableData.length;
      return this.tableData.length;
    }
  },
  data() {
    return {
        modals: {
           classic: false
        },
        loading: false,
        tableColumns: [
            { prop: "fullname", label: this.$t("fullname") },
            { prop: "phone_number", label: this.$t("phone") },
            { prop: "country", label: this.$t("country") },
            { prop: "community", label: this.$t("community") },
            { prop: "email", label: this.$t("email"), minWidth: 100 },
            { prop: "ngo", label: this.$t("ngo") },
            { prop: "trainer", label: this.$t("trainer") },
            { prop: "created_at", label: this.$t("date") }
        ],
        tableData: [],
        pagination: {
          perPage: 50,
          currentPage: 1,
          perPageOptions: [50, 100, 200, 500],
          total: 0
        },
        searchQuery: "",
        propsToSearch: ["fullname"],
        formAnswers: []
    };
  },
  created() {
     this.getSurveyAnswer();
  },
  methods: {
      // get survey answer
      getSurveyAnswer() {
          this.loading = true;
          SurveyAnswerResource.list({ survey_form_id: this.$route.params.id })
          .then(res => {
              this.loading = false;
              this.tableData = res.data;
          })
          .catch(error => {
              this.loading = false;
              console.log("Error: ", error);
          }) 
      },

      handleCloseModal(){
         this.modals.classic = false;
      },

      viewAnswers(index, row) {
         this.formAnswers = row.answers ? JSON.parse(row.answers) : [];
         this.modals.classic = true;
      },

      createFormBuilder() {
         this.$router.push({ name: "FormBuilder" });
      }
  }
};
</script>
<style lang="scss">
.el-table .td-actions {
  button.btn {
    margin-right: 5px;
  }
}
a.custom-link {
  background-color: #2c2c2c;
  padding: 20px;
  color: white;
  text-transform: uppercase;
  font-weight: 700;
}
a.custom-link:hover {
  background-color: #6bd098;
  color: white;
}
</style>
